export const version = '/admin/v1';
